<template>
    <div>
        <div class="row comment-row">
            <div class="col comment-avatar-column">
                <avatar 
                    :user="comment.created_by"
                />
            </div>
            <div class="col">
                <span 
                    v-if="comment.created_by" 
                    class="comment-user-name"
                >
                    {{ comment.created_by.name }}
                </span>
                <ui-icon-button 
                    v-if="canDelete" 
                    type="secondary" 
                    size="small" 
                    icon="delete" 
                    class="comment-delete-button"
                    @click="destroy" 
                    :loading="isBusy"
                /> 
                <div class="comment-content">
                    {{ comment.content }}
                </div>
                <span class="comment-date">{{ comment.created_at | humanDayTime('ddd', 'h:mma', 'DD/MM/YY') }}</span>
            </div>
        </div>
    </div>
</template>

<style lang="scss">
    .comment-row {
        .comment-date { float:right; font-size: .8rem; color: #999; padding-top: .5rem; }
        .comment-delete-button { float:right; margin-top: .5rem }
        .comment-avatar-column { max-width: 45px; padding: .25em 15px; }
        .comment-user-name { font-weight: bold; display: inline-block; padding: .5rem 0; }
        .comment-content { background: #fafafa; border-radius: 3px; padding: 1rem; margin-top: .25rem; }
    }

    .comment-content {
        white-space: pre-line;
    }
</style>

<script>
    import Filters from '../../filters'
    import { CommentSchema, CommentResource } from '../../classes/Api/Comment'

    export default {
        filters: Filters,
        props: {
            comment: {
                type: Object,
                default() {
                    return new CommentSchema({ created_by: {} })
                }
            }
        },
        data() {
            return {
                isBusy: false
            }
        },
        computed: {
            canDelete() {
                return parseInt(this.comment.created_by_id) === window.marque.ui.user.id
            }
        },
        methods: {
            destroy() {
                if (!confirm('Are you sure you want to delete this comment?')) {
                    return;
                }

                this.isBusy = true;

                CommentResource.destroy(this.comment.id).then(response => {
                    this.$emit('destroyed')
                    this.isBusy = false
                }, e => { handleApiError(e); this.isBusy = false })
            }
        }
    }
</script>